/**
 * Leaflet marker-icon shim.
 *
 * Leaflet defaults to relative `marker-icon.png` URLs that webpack used to
 * resolve via image-loaders; Vite doesn't ship that compatibility shim, so
 * we point Leaflet at the bundled assets explicitly. Run once at startup
 * (imported from main.tsx).
 */

import L from "leaflet";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

// The default Leaflet icon class merges options from a static field; we
// replace those URLs once so every <Marker> in the app picks the right
// assets.
L.Icon.Default.mergeOptions({
  iconRetinaUrl: iconRetina,
  iconUrl: icon,
  shadowUrl: iconShadow,
});
